import { render, staticRenderFns } from "./HealthWeeklyChart.vue?vue&type=template&id=658a8ada&scoped=true&"
import script from "./HealthWeeklyChart.vue?vue&type=script&lang=ts&"
export * from "./HealthWeeklyChart.vue?vue&type=script&lang=ts&"
import style0 from "./HealthWeeklyChart.vue?vue&type=style&index=0&id=658a8ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a8ada",
  null
  
)

export default component.exports